<template>
    <div class="container-fluid vh-100">
        <div v-if="signedup == false" class="row justify-content-center">
            <div class="col-xxl-6 col-md-8">
                <div class="text-center my-4">
                    <img :src="logo" class="img-fluid"/>
                </div>
                <div class="row justify-content-center">
                    <div class="app--card card col-12 col-sm-10 col-md-8 col-xxl-6">
                        <div class="card-body">
                            <form class="auth-signup-form" novalidate @submit.prevent="submit($event)">
                                <div v-if="!response.type" class="app--card-title text-uppercase">
                                    Start Your 14 Day Free Trial
                                </div>
                                <app--alert v-if="response.type" @dismiss="dismiss"
                                    :close="true"
                                    :description="response.description"
                                    :icon="response.icon"
                                    :title="response.title"
                                    :type="response.type"
                                ></app--alert>
                                <div class="mb-3">
                                    <input type="text" autocomplete="off" required maxlength="64"
                                        class="form-control form-control-lg"
                                        v-model="company" placeholder="Company name"
                                        v-on:blur="$validate"/>
                                    <div class="invalid-feedback"></div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-12 col-md-6">
                                        <input type="first_name" autocomplete="off" required maxlength="32"
                                            class="form-control form-control-lg"
                                            v-model="first_name" placeholder="First name"
                                            v-on:blur="$validate"/>
                                        <div class="invalid-feedback"></div>
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <input type="last_name" autocomplete="off" required maxlength="32"
                                            class="form-control form-control-lg"
                                            v-model="last_name" placeholder="Last name"
                                            v-on:blur="$validate"/>
                                        <div class="invalid-feedback"></div>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input type="email" autocomplete="off" required class="form-control form-control-lg"
                                        v-model="email" placeholder="Email address"
                                        v-on:blur="$validate"/>
                                    <div class="invalid-feedback"></div>
                                </div>
                                <div class="mb-3">
                                    <app--phone required class="input-group-lg" v-model="phone" :allow-ext="false"
                                        placeholder="Mobile phone" name="phone" label="Mobile phone">
                                    </app--phone>
                                    <div class="invalid-feedback"></div>
                                </div>
                                <div class="d-grid mb-3">
                                    <app--button type="submit" class="btn btn-primary btn-lg"
                                        label="Sign up. It's Free."
                                        :loading="status.loading">
                                    </app--button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <p class="mt-2 mb-4 text-muted text-center">
                    By signing up, you agree to our <a href="https://precisefp.com/terms-of-service" target="_blank" class="text-muted font-weight-bold">Terms & Conditions</a>.
                </p>
            </div>
        </div>
        <div v-if="signedup == true" class="row justify-content-center">
            <div class="col-xxl-6 col-md-8">
                <div class="text-center my-4">
                    <img :src="logo" class="img-fluid"/>
                </div>
                <div class="row justify-content-center">
                    <div class="app--card card col-12 col-sm-10 col-md-8 col-xxl-6">
                        <div class="card-body">
                            <div class="app--card-title text-uppercase mb-4">
                                Welcome aboard!
                            </div>
                            <p class="text-start">
                                We would like to thank you for choosing <strong>PreciseFP&trade;</strong>.
                            </p>
                            <p class="text-start mb-4">
                                Please check your inbox for an activation email.
                            </p>
                            <p class="text-start">
                                Sincerely,<br />Your PreciseFP&trade; Team
                            </p>
                            <div class="fb-follow"
                                 data-href="https://www.facebook.com/precisefp"
                                 data-layout="standard"
                                 data-size="large"
                                 data-show-faces="false"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from './store'

    export default {
        computed: {
            logo()     { return store.state.logo     },
            status()   { return store.state.status   },
            response() { return this.status.response },
        },
        data() {
            return {
                signedup: false,
                company: '',
                first_name: '',
                last_name: '',
                email: '',
                phone: {code: '+1', number: '', country: 'US'},
                timezone: 'UTC',
            }
        },
        mounted() {
            try {
                this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            } catch (err) {
                this.timezone = 'UTC'
            }
            this.prepopulate()
        },
        methods: {
            prepopulate() {
                if (!!this.$route.query.name) {
                    this.company = this.$route.query.name
                }
                if (!!this.$route.query.email) {
                    this.email = this.$route.query.email
                }
                if (!!this.$route.query.first) {
                    this.first_name = this.$route.query.first
                }
                if (!!this.$route.query.last) {
                    this.last_name = this.$route.query.last
                }
                if (!!this.$route.query.country) {
                    this.phone.country = this.$route.query.country
                }
                if (!!this.$route.query.phone) {
                    this.phone.number = this.$route.query.phone
                }
            },
            submit(event) {
                this.$validate(event).then(() => {
                    if (window.analytics) { 
                        window.analytics.track('signup') 
                    }
                    
                    let payload = {
                        company: this.company,
                        first_name: this.first_name,
                        last_name: this.last_name,
                        email: this.email,
                        phone: this.phone,
                        timezone: this.timezone
                    }
                    store.dispatch('signup', payload).then(response => { this.signedup = true })

                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
</script>
